export enum TAG_VARIANTS {
    ROUNDED,
    SQUARE,
}
